module.exports = __webpack_public_path__ + "img/logo_BioMed.e566e2f8.png";